import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Menu, MenuButton, MenuDivider, MenuItem } from "@szhsin/react-menu";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { fetchActions } from "../redux/storesSagas";
import { IconDots } from "../../../../assets/images/svg";

export function StoreActionsMenu({ item, onMenuItemClick }) {
  const dispatch = useDispatch();
  const currentStoreActions = useSelector((state) => state.stores.currentStoreActions);
  const actionsLoading = useSelector((state) => state.stores.actionsLoading);
  return (
    <Menu
      portal
      menuButton={
        <MenuButton title="Actions">
          <IconDots />
        </MenuButton>
      }
      onMenuChange={({ open }) => {
        if (open) {
          dispatch(fetchActions(item.store.id));
        }
      }}
      onItemClick={(eventObj) => onMenuItemClick(eventObj, item)}
      direction="left"
      align="start"
      transition
    >
      {actionsLoading ? (
        <LoadingAnimation uiLoader />
      ) : (
        <>
          <MenuItem href={currentStoreActions?.dashboardLink || ""}>Open Dashboard</MenuItem>
          <MenuDivider />

          <MenuItem href={currentStoreActions?.settingsLink || ""}>Open Settings</MenuItem>
          <MenuDivider />

          <MenuItem value="recalculate">
            <span>Recalculate</span>
          </MenuItem>
          <MenuDivider />

          <MenuItem value="reimportRecalculate">
            <span>Reimport & Recalculate</span>
          </MenuItem>
          <MenuDivider />
        </>
      )}
    </Menu>
  );
}
